import t from '@jetshop/intl';
import ProductSpecifications from '@jetshop/ui/ProductSpecifications/ProductSpecifications';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import React, { useMemo } from 'react';
import { makeModelFilterTable } from '../../utils/modelFilter';
import { theme } from '../Theme';
import ReadMore from '../Theme/ReadMore';

const Description = styled('article')``;

export const SectionHeading = styled('h2')`
  font-weight: 600;
  font-size: ${theme.themeFontSizes.xl};
  margin-bottom: 0.25em;
`;

export const ProductSection = styled('section')`
  line-height: 1.5;

  width: 100%;
  padding-bottom: ${theme.space[3]};

  ${theme.below.md} {
    margin: 0;
    padding-bottom: ${theme.space[0]};
    margin-top: ${theme.space[3]};
  }

  ${theme.above.md} {
    width: calc(50% - 16px);
  }

  ${theme.above.lg} {
    :nth-of-type(odd) {
      width: calc(60% - 24px);
    }
    :nth-of-type(even) {
      width: calc(40% - 24px);
    }
  }
  ul.payment-options-list {
    font-size: 16px;
    font-weight: 600;
  }
`;

const fitToHtmlCSS = css`
  color: ${theme.colors.black};
  width: 100% !important;
  margin-top: ${theme.space[3]};

  ${theme.above.md} {
    margin-top: ${theme.space[3]};
  }

  h2 {
    margin-bottom: ${theme.space[1]};
  }

  th {
    display: none;
  }

  table {
    color: ${theme.colors.black};
    width: 100%;
    font-size: 10px;

    ${theme.above.md} {
      font-size: 1rem;
    }

    tr {
      &:first-child {
        background: ${theme.colors.black} !important;
        color: ${theme.colors.white};
      }

      &:nth-child(even) {
        background: #e3e3e3;
      }

      &:nth-child(odd) {
        background: ${theme.colors.white};
      }

      td {
        padding: 0.75rem;

        ${theme.above.md} {
          padding: 0.75rem 1.25rem;
        }
      }
    }
  }
`;

const specificationsCSS = css`
  tr {
    th {
      width: 35%;
    }
    td {
      width: 60%;
    }
  }
`;

const ProductInfo = ({ product }) => {
  const stringFields = product?.customFields?.filter(
    field => field.type === 'STRING'
  );
  const fitToHtml = product?.customFields?.filter(
    field => field.key === 'Passar-till'
  );
  const htmlValue = fitToHtml[0]?.htmlValue;
  const modelFilterTable = useMemo(() => {
    const modelFilter = product?.customFields?.find(
      field => field.key === 'modellfilter'
    );
    return modelFilter?.items ? makeModelFilterTable(modelFilter.items) : null;
  }, [product?.customFields]);

  return (
    <>
      {product.description && (
        <ProductSection className="product-description">
          <SectionHeading>{t('Product description')}</SectionHeading>
          <Description
            dangerouslySetInnerHTML={{
              __html: product.description
            }}
          />
        </ProductSection>
      )}
      {/* {product.customFields?.length > 0 && (
        <ProductSection>
          <SectionHeading>{t('Specifications')}</SectionHeading>
          <ProductSpecifications fields={product.customFields} />
        </ProductSection>
      )} */}

      {stringFields.length > 0 && (
        <ProductSection className={specificationsCSS}>
          <SectionHeading>{t('Specifications')}</SectionHeading>
          <ProductSpecifications fields={stringFields} />
        </ProductSection>
      )}

      {modelFilterTable?.length ? (
        <ProductSection className={fitToHtmlCSS}>
          <SectionHeading>{t('Passar till')}</SectionHeading>
          <ReadMore condition={modelFilterTable.length > 7}>
            <table
              style={{ width: '100%' }}
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <colgroup>
                <col span={4} width={64} />
              </colgroup>
              <tbody>
                <tr>
                  <td>{t('Typ')}</td>
                  <td>{t('Märke')}</td>
                  <td>{t('Modell')}</td>
                  <td>{t('Övrig information')}</td>
                </tr>
                {modelFilterTable.map((row, idx) => (
                  <tr key={idx}>
                    {row.map(item => (
                      <td key={item.id}>{item.value}</td>
                    ))}
                    {row.length < 4 &&
                      Array.from({ length: 4 - row.length }).map((_, i) => (
                        <td key={`empty-${i}`}></td>
                      ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </ReadMore>
        </ProductSection>
      ) : (
        fitToHtml.length > 0 && (
          <ProductSection className={fitToHtmlCSS}>
            <SectionHeading>{t('Passar till')}</SectionHeading>
            <ReadMore condition={htmlValue?.length > 1000}>
              <div dangerouslySetInnerHTML={{ __html: htmlValue }} />
            </ReadMore>
          </ProductSection>
        )
      )}
    </>
  );
};

export default ProductInfo;
